/**
 * Lets the global saga tear down the Web3Auth session without redux holding a
 * function in state. `GlobalProvider` registers the shared provider's `logout`
 * here on mount.
 */
type LogoutHandler = () => Promise<void>;

let logoutHandler: LogoutHandler | null = null;

export const registerLogoutHandler = (handler: LogoutHandler | null): void => {
  logoutHandler = handler;
};

export const invokeLogoutHandler = async (): Promise<void> => {
  if (!logoutHandler) return;
  await logoutHandler();
};
